import styled from 'styled-components';

import { subtitle } from '../../../tokens';

export const Subtitle = styled.div({ overflowWrap: 'break-word', hyphens: 'auto', ...subtitle });
